import axios from "axios";
import { APIURL } from "./../Constantes";
import { getCabecera } from "../utils/getCabecera";
import { getError } from "../utils/errors";

const urlUsuario = "User";

export const getAgentes = async () => {
    return await axios.get(`${APIURL}/${urlUsuario}/ObtenerAgentes`, {
        headers: getCabecera(),
    })
        .then((Response) => {
            return Response.data;
        })
        .catch((Error) => {
            return getError(Error);
        })
}
export const bajaUsuario = async ({ idUsuario, estatus }) => {
    return await axios.put(`${APIURL}/${urlUsuario}/Information/Drop/${idUsuario}/${estatus}`, {}, {
        headers: getCabecera(),
    })
        .then((Response) => {
            return Response.data;
        })
        .catch((Error) => {
            return getError(Error);
        })
}
export const updateUsuarioInformacion = async ({ idUsuario, payload }) => {
    return await axios.put(`${APIURL}/${urlUsuario}/Information/${idUsuario}`, payload, {
        headers: getCabecera(),
    })
        .then((Response) => {
            return Response.data;
        })
        .catch((Error) => {
            return getError(Error);
        })
}
export const obtenerUsuarioProfile = async () => {
    return await axios.get(`${APIURL}/${urlUsuario}/Profile`, {
        headers: getCabecera(),
    }).then((Response) => {
        return Response.data;
    }).catch((Error) => {
        return {};
    })
}
export const obtenerUsuarioByIdUsuario = async ({ IdUsuario }) => {
    return await axios.get(`${APIURL}/${urlUsuario}/Usuario/${IdUsuario}`, {
        headers: getCabecera(),
    }).then((Response) => {
        return Response.data;
    }).catch((Error) => {
        return {};
    })
}
export const obtenerUsuariosTipoUsuario = async ({ IdTipoUsuario }) => {
    return await axios.get(`${APIURL}/${urlUsuario}/Usuarios/${IdTipoUsuario}`, {
        headers: getCabecera(),
    }).then((Response) => {
        return Response.data;
    }).catch((Error) => {
        return [];
    })
}
export const newUsuario = async ({ payload }) => {
    return await axios.post(`${APIURL}/${urlUsuario}/Usuarios/create`, payload, {
        headers: getCabecera(),
    }).then((Response) => {
        return Response.data;
    }).catch((Error) => {
        return getError(Error);
    })
}
export const changePasswordByUser = async ({ IdUser, password }) => {
    return await axios.put(`${APIURL}/${urlUsuario}/reset-password/update/${IdUser}`, { password }, {
        headers: getCabecera(),
    }).then((Response) => {
        return Response.data;
    }).catch((Error) => {
        return getError(Error);
    })
}
export const updateUsuario = async ({ IdUsuario, payload }) => {
    return await axios.put(`${APIURL}/${urlUsuario}/Usuarios/update/${IdUsuario}`, payload, {
        headers: getCabecera(),
    })
        .then((Response) => {
            return Response.data;
        })
        .catch((Error) => {
            return getError(Error);
        })
}
export const getCuentasMetasAll = async ({ nombre, referencia }) => {
    return await axios.get(`${APIURL}/${urlUsuario}/Cuentas/${nombre}/${referencia}`, {
        headers: getCabecera(),
    }).then((Response) => {
        return Response.data;
    }).catch((Error) => {
        return [];
    })
}
export const newCargoCuenta = async ({ payload }) => {
    return await axios.post(`${APIURL}/${urlUsuario}/bill/newMovement`, payload, {
        headers: getCabecera(),
    }).then((Response) => {
        return Response.data;
    }).catch((Error) => {
        return getError(Error);
    })
}
export const getMovimientosCuentaAll = async ({ fechaInicio, fechaFinal }) => {
    return await axios.get(`${APIURL}/${urlUsuario}/bill/${fechaInicio}/${fechaFinal}/find`, {
        headers: getCabecera(),
    }).then((Response) => {
        return Response.data;
    }).catch((Error) => {
        return [];
    })
}
export const getMovimientosCuentaBancariaAll = async ({ fechaInicio, fechaFinal }) => {
    return await axios.get(`${APIURL}/${urlUsuario}/bill/bank/${fechaInicio}/${fechaFinal}/find`, {
        headers: getCabecera(),
    }).then((Response) => {
        return Response.data;
    }).catch((Error) => {
        return [];
    })
}
export const newCargarMovimientosCuentaBancaria = async ({ payload }) => {
    return await axios.post(`${APIURL}/${urlUsuario}/bill/bank/upload`, payload, {
        headers: getCabecera(),
    }).then((Response) => {
        return Response.data;
    }).catch((Error) => {
        return getError(Error);
    })
}
export const getPermisosUsuario = async () => {
    return await axios.get(`${APIURL}/${urlUsuario}/Permission`, {
        headers: getCabecera(),
    }).then((Response) => {
        return Response.data;
    }).catch((Error) => {
        return [];
    })
}
export const putVerificarCuenta = async ({ IdCuenta, Verificado }) => {
    return await axios.put(`${APIURL}/${urlUsuario}/Verified/${IdCuenta}`,
        {
            Verificado
        },
        {
            headers: getCabecera()
        }).then((Response) => {
            return Response.data;
        }).catch((Error) => {
            return getError(Error);
        })
}
export const putActulizarDatosContacto = async ({ Referencia, nombre, apellidoP, apellidoM, telefono, correo }) => {
    return await axios.put(`${APIURL}/${urlUsuario}/Contrating/Data/${Referencia}`,
        {
            Nombre: nombre,
            Apellido_Paterno: apellidoP,
            Apellido_Materno: apellidoM,
            Telefono_Contacto: telefono,
            Direccion_Contacto: correo
        },
        {
            headers: getCabecera()
        }).then((Response) => {
            return Response.data;
        }).catch((Error) => {
            return getError(Error);
        })
}
/**
** Metodos para administrar los usuarios ctizacion
*/
export const updateClienteCoitizacion =  async ({ idCliente, Nombre, Telefono, EMail }) => {
    return await axios.put(`${APIURL}/${urlUsuario}/Update/Client/${idCliente}`,
        {
            Nombre,
            Telefono,
            EMail
        },
        {
            headers: getCabecera()
        }).then((Response) => {
            return Response.data;
        }).catch((Error) => {
            return getError(Error);
        })
}
export const postNuevoClienteCotizacion = async ({ Nombre, Telefono, EMail }) => {
    return await axios.post(`${APIURL}/${urlUsuario}/Register/Client`,
        {
            Nombre,
            Telefono,
            EMail
        },
        {
            headers: getCabecera()
        }).then((Response) => {
            return Response.data;
        }).catch((Error) => {
            return getError(Error);
        })
}
export const getClientesCotizacion = async ({ Pagina, Registros, idCliente }) => {
    return await axios.get(`${APIURL}/${urlUsuario}/Client/${idCliente}/${Pagina}/${Registros}`,
        {
            headers: getCabecera()
        }).then((Response) => {
            return Response.data;
        }).catch((Error) => {
            return getError(Error);
        })
}
export const getClientesAllCotizacion = async () => {
    return await axios.get(`${APIURL}/${urlUsuario}/Client/All`,
        {
            headers: getCabecera()
        }).then((Response) => {
            return Response.data;
        }).catch((Error) => {
            return getError(Error);
        })
}
export const deleteClientesCotizacion = async ({ idCliente }) => {
    return await axios.delete(`${APIURL}/${urlUsuario}/Delete/Client/${idCliente}`,
        {
            headers: getCabecera()
        }).then((Response) => {
            return Response.data;
        }).catch((Error) => {
            return getError(Error);
        })
}